// extracted by mini-css-extract-plugin
export default {"Content":"ConfirmPopup_Content__V3Lpp"};